<ng-container *ngIf="modeStrategy.inputMode | async as inputMode">
    <ms-numpad-error *ngIf="error" [error]="error"></ms-numpad-error>
    <ms-numpad-host msNumpadScroll *ngIf="inputMode === StakeInputMode.Field" [id]="keypadId" [error]="null"></ms-numpad-host>
</ng-container>
